var Aneox;
(function(Aneox) {
    (function(Controllers) {
        'use strict';

        var Home = (function() {

            var self;
            var animState;
            var windowHeight;
            var galleryInterval;
            var instagramInterval;

            function Home(animations) {
                self = this;
                self.timeline = animations.timeline;
                self.producersData;
                self.instagramData;
                self.nbProduceur = 0;
                self.nbInstagram = 0;
            }

            Home.prototype.enter = function() {
                
                self.setGalleryData();
                self.setInstagramData();
                
                self.timeline.call(function() { animState = {}; });

                self.timeline.set('#home', { display: 'block', opacity: 0 });
                self.timeline.set('#home-aside', { display: 'block', opacity: 0 });
                self.timeline.set('#home-aside .button-mask', { display: 'block', x: '0%' });

                self.timeline.set('#home .mast-next', { opacity: 0 });
                self.timeline.set('#home-mast h2 i', { scale: 1, opacity: 1 });

                self.timeline.call(self.handleWindowResize.bind(self));
                self.timeline.call(function() { $('html, body').scrollTop(0); });

                self.timeline.to('#home', 0.5, { opacity: 1 });
                self.timeline.to('#home-aside', 0.5, { opacity: 1 }, '-=0.5');
                self.timeline.to('#home-aside .button-mask', 0.5, { x: '100%', display: 'none' });

                self.timeline.call(function() {
                    $('#home-selection .home-selection-gallery-image').removeClass('active');
                    $('#home-selection .home-selection-gallery-image:eq(0)').addClass('active');

                    $('#home-selection-menu li').removeClass('active');
                    $('#home-selection-menu li:eq(0)').addClass('active');

                    galleryInterval = setInterval(self.nextGalleryItem, 3333);
                    instagramInterval = setInterval(self.nextInstagramItem, 3333);
                });

                if (Aneox.Data.Config.runtime.supportsScrollEvents) {
                    self.timeline.set('#home-plot-line', { display: 'none' }, 0);

                    self.timeline.set('#home .content-block:eq(0)', { opacity: 0 }, 0);
                    self.timeline.set('#home .content-block:eq(3)', { opacity: 0 }, 0);

                    self.timeline.set('#home .mask', { display: 'block', top: 0 }, 0);
                    self.timeline.to('#home-mast .mask', 1, { top: '100%' });

                    self.timeline.call(function() {
                        if ($(window).scrollTop() !== 0) return;
                        TweenMax.fromTo('#home .mast-next', 1, {opacity: 0, y: -15 }, { opacity: 1, y: 0 });
                        TweenMax.fromTo('#home-mast h2 i', 1, { scale: 1, opacity: 1 }, { scale: 1.25, opacity: 0.75, yoyo: true, repeat: -1 });
                    });
                }
            };

            Home.prototype.leave = function(callback) {
                self.timeline.call(function() {
                    TweenMax.killChildTweensOf('#home');
                    
                    if (galleryInterval !== undefined) {
                        clearInterval(galleryInterval);
                        galleryInterval = undefined;
                    }
                    
                    if (instagramInterval !== undefined) {
                        clearInterval(instagramInterval);
                        instagramInterval = undefined;
                    }
                });

                self.timeline.to('#home', 0.5, { display: 'none', opacity: 0 });
                self.timeline.to('#home-aside', 0.5, { display: 'none', opacity: 0 }, '-=0.5');
                
                if (callback) self.timeline.call(callback);
            };

            Home.prototype.handleWindowResize = function() {
                windowHeight = $(window).height();

                $('#home-contact-right').innerHeight($('#home-contact-left').innerHeight() + 2);

                var plotLineTop = $('#home-mast h2').offset().top + $('#home-mast h2').innerHeight() - 50;
                var plotLineBottom = $('#home-selection h2').offset().top - 50;
                $('#home-plot-line').css('top', plotLineTop + 'px');
                $('#home-plot-line').css('height', (plotLineBottom - plotLineTop) + 'px');
            };

            Home.prototype.handleScroll = function(event) {
                
                if (!Aneox.Data.Config.runtime.supportsScrollEvents) return;
                if (!animState) return;

                if (!animState.scrollArrow && $(window).scrollTop() > 0) {
                    TweenMax.killTweensOf('#home .mast-next');
                    TweenMax.killTweensOf('#home-mast h2 i');
                    TweenMax.to('#home .mast-next', 0.5, { opacity: 0 });
                    TweenMax.to('#home-mast h2 i', 0.5, { scale: 1, opacity: 1 });
                    animState.scrollArrow = true;
                }

                if (!animState.plotLine && $(window).scrollTop() > 0) {
                    var height = $('#home-plot-line').height();
                    TweenMax.set('#home-plot-line', { display: 'block', height: 0 });
                    TweenMax.to('#home-plot-line', 3, { height: height });
                    animState.plotLine = true;
                }

                if (!animState.bourgogne && $('#home-terroir .content-block:eq(0)')[0].getBoundingClientRect().top < windowHeight * 0.5) {
                    TweenMax.to('#home-terroir .content-block:eq(1) .mask', 1, { top: '100%' });
                    TweenMax.to('#home-terroir .content-block:eq(0)', 1, { opacity: 1, delay: 0.5 });
                    animState.bourgogne = true;
                }

                if (!animState.champagne && $('#home-terroir .content-block:eq(2)')[0].getBoundingClientRect().top < windowHeight * 0.5) {
                    TweenMax.to('#home-terroir .content-block:eq(2) .mask', 1, { top: '100%' });
                    TweenMax.to('#home-terroir .content-block:eq(3)', 1, { opacity: 1, delay: 0.5 });
                    animState.champagne = true;
                }
            };

            Home.prototype.mouseEnter = function(area) {
                if (Aneox.Data.Config.runtime.mobile) return;

                switch (area) {
                    case 'bourgogne':
                        $('#home-terroir .content-block:eq(1) .placeholder').addClass('zoom');
                        break;
                    case 'champagne':
                        $('#home-terroir .content-block:eq(2) .placeholder').addClass('zoom');
                        break;
                    case 'mast':
                        TweenMax.to('#home .mast-next', 0.5, { y: 15 });
                        break;
                }
            };

            Home.prototype.mouseLeave = function(area) {
                if (Aneox.Data.Config.runtime.mobile) return;

                switch (area) {
                    case 'bourgogne':
                        $('#home-terroir .content-block:eq(1) .placeholder').removeClass('zoom');
                        break;
                    case 'champagne':
                        $('#home-terroir .content-block:eq(2) .placeholder').removeClass('zoom');
                        break;
                    case 'mast':
                        TweenMax.to('#home .mast-next', 0.5, { y: 0 });
                        break;
                }
            };

            Home.prototype.scrollToContent = function() {
                $('html, body').animate({
                    scrollTop: $(window).height() - 100
                }, 1000);
            };

            Home.prototype.nextGalleryItem = function() {
                var index = $('#home-selection .home-selection-gallery-image.active').index();
                var producers = self.nbProduceur - 1;
                index += 1;
                //if (index > 2) index = 0;
                if (index > producers) index = 0;
                
                self.setGalleryItem(index, true);    
            };

            Home.prototype.setGalleryItem = function(index, keepInterval) {
                if (!keepInterval && galleryInterval !== undefined) {
                    clearInterval(galleryInterval);
                    galleryInterval = undefined;
                }

                $('#home-selection .home-selection-gallery-image').removeClass('active');
                $('#home-selection .home-selection-gallery-image:eq(' + index + ')').addClass('active');

                $('#home-selection-menu li').removeClass('active');
                $('#home-selection-menu li:eq(' + index + ')').addClass('active');
                
                $("#home-domain .producers-name h2").removeClass('active');
                $('#home-domain .producers-name h2:eq(' + index + ')').addClass('active');
            };
            
            Home.prototype.setGalleryData = function(){
                $("#home-selection .gallery-item").empty();
                $("#home-selection-menu").empty();
                $("#home-domain .producers-name").empty();
                
                var producers = _.filter(self.producersData, { home: "1" });
                self.nbProduceur = 0;
                _.forEach(producers, function(producer){
                    $('#home-selection .gallery-item').append('<div class="home-selection-gallery-image lazyload fullscreen background-cover placeholder" data-bg="'+ producer.imageLarge +'"></div>');
                    $("#home-selection-menu").append('<li onclick="app.controllers.home.setGalleryItem('+ self.nbProduceur +')"><i></i></li>');
                    $("#home-domain .producers-name").append('<h2 translate>'+ producer.htmlName +'</h2>');
                    self.nbProduceur++;
                });
                
            };

            Home.prototype.setInstagramData = function(){
                $("#home-contact-right-top").empty();
                $("#home-contact-right-down-instagram").empty();
                self.nbInstagram = 0;
                _.forEach(self.instagramData, function(instagram){
                    $("#home-contact-right-top").append('<div class="background-cover lazyload home-instagram-gallery-image" data-bg="'+ instagram.image +'"></div>');
                    $("#home-contact-right-down-instagram").append('<p>'+ _.truncate(instagram.hashtag,{'length': 70, 'separator': '&hellip;'}) +'</p>');
                    self.nbInstagram++;
                });
            };

            Home.prototype.nextInstagramItem = function() {
                var index = $('#home-contact-right-top .home-instagram-gallery-image.active').index();
                var instagram = self.nbInstagram - 1;
                index += 1;
                //if (index > 2) index = 0;
                if (index > instagram) index = 0;
                
                self.setInstagramItem(index, true);    
            };

            Home.prototype.setInstagramItem = function(index, keepInterval) {
                if (!keepInterval && instagramInterval !== undefined) {
                    clearInterval(instagramInterval);
                    instagramInterval = undefined;
                }

                $('#home-contact-right-top .home-instagram-gallery-image').removeClass('active');
                $('#home-contact-right-top .home-instagram-gallery-image:eq(' + index + ')').addClass('active');

                $('#home-contact-right-down-instagram p').removeClass('active');
                $('#home-contact-right-down-instagram p:eq(' + index + ')').addClass('active');
                
            };



            return Home;
        })();

        Controllers.Home = Home;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));